
<script>
import {defineComponent} from "vue";
import UserService from "../services/user.service";
import router from "../router";
import {useUserStore} from "../stores/user";
import {mapActions, mapState} from "pinia";
import {useAlertsStore} from "../stores/alerts";
import LoadingButton from "../components/LoadingButton.vue";
import { useConfigStore } from "../stores/config";
import HeadlineComponent from "../components/HeadlineComponent.vue";

export default defineComponent({
  name: 'LoginView',
  components: { LoadingButton, HeadlineComponent },
  data(){
    return {
      email: "",
      password: "",
      loading: false,
      emailError: false,
      passwordError: false,
    }
  },
  computed: {
    ...mapState(useConfigStore, ['login_text', 'registration_enabled'])
  },
  async mounted() {
    await this.getConfig();
  },
  methods: {
    ...mapActions(useUserStore, {setUser: 'set'}),
    ...mapActions(useAlertsStore, {addAlert: 'add'}),
    ...mapActions(useConfigStore, {getConfig: 'get'}),
    async login() {
      this.loading = true;
      this.emailError = false;
      this.passwordError = false;
      try {
        let res = await UserService.login(this.email, this.password)
        this.addAlert('success', 'Herzlich willkommen!');
        this.setUser(res.data);
        if(res.data.confirmed) {
          router.push({path: '/'});
        } else {
          router.push({path:'/confirm'});
        }
      } catch (err) {
        if(err) {
          if(err.response.status == 404) {
            this.emailError = true
          } else if(err.response.status == 403) {
            this.passwordError = true
          } else if(err.response.status == 401) {
            this.addAlert('danger', "Dein Account wurde deaktiviert.")
            window.scrollTo(0,0);
          } else {
            this.addAlert('danger', err.response.data.message);
          }
        }
      }
      this.loading = false;
    }
  }
})

</script>

<template>
  <HeadlineComponent>Login</HeadlineComponent>
  <form class="form-horizontal" @submit.prevent="login()">
    <div v-html="login_text" class="quill-generated-text"></div>
    <div class="form-group">
      <input type="email" class="form-control" id="inputEmail" v-model="email" placeholder="E-Mail" aria-label="E-Mail" :class="{'is-invalid': emailError}">
      <div class="invalid-feedback">
        Die E-Mailadresse ist nicht bekannt.
      </div>
    </div>
    <div class="form-group">
      <input type="password" class="form-control" id="inputPassword" v-model="password" placeholder="Passwort" aria-label="Password" :class="{'is-invalid': passwordError}">
      <div class="invalid-feedback">
        Das Passwort ist falsch.
      </div>
    </div>
    <div class="form-group">
      <LoadingButton :loading="loading" class="btn-primary">Login</LoadingButton>
    </div>
    <p>Hast du dein <RouterLink :to="{ path: '/requestpasswordchange', query: {email}}">Passwort vergessen?</RouterLink></p>
    <p v-if="registration_enabled">Oder musst du dich noch <RouterLink to="/register">registrieren?</RouterLink></p>
  </form>
</template>

<style scoped>
form {
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  padding: 15px;
}
.form-group {
  text-align: center;
}
</style>